import LdfTab from "@features/creation/ldf/components/LdfTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ListTree } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ldf/")({
  loader: requirePermission(PERMISSIONS.CREATION.LDF.VIEW),
  staticData: {
    title: "LDF / Nomenclatures",
    icon: ListTree,
    tab_icon: ListTree,
    permission: PERMISSIONS.CREATION.LDF.VIEW,
    module: "creation",
    section: "Creation",
    order: 22,
    description: "Listes de Fabrication",
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: LdfTab,
});
